import _ from 'lodash'

import { DELIVERY_GUIDE } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: DELIVERY_GUIDE,
  params: {},
  needFetchFillInfo: false,
  formatData(data) {
    if (data.productSupport) {
      data.productSupport = data.productSupport.join(',')
    }
    return data
  },
  view: {
    title: '添加指导配置',
    labelPosition: 'right',
    width: '700px',
    content: [
      {
        $id: 'docName',
        $type: 'input',
        label: '指导配置名称',
        $el: {
          placeholder: '指导配置名称',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: '指导配置名称'
          }
        ]
      },
      {
        $id: 'guideType',
        $type: 'select',
        label: '指导配置类型',
        $default: null,
        $options: [
          {
            label: '价值配置指导',
            value: 'VALUE_GUIDE'
          },
          {
            label: '岗位桌面配置指导',
            value: 'POSITION_GUIDE'
          },
          {
            label: '注意事项指导',
            value: 'ATTENTION_GUIDE'
          }
        ],
        rules: [
          {
            notEmpty: '指导配置类型'
          }
        ]
      },
      {
        $id: 'guideSubType',
        $type: 'input',
        label: '指导配置子类型',
        $el: {
          placeholder: '指导配置子类型',
          suffixIcon: 'el-icon-edit'
        }
      },
      {
        $id: 'guideDesc',
        $type: 'input',
        label: '指导描述',
        $el: {
          placeholder: '请输入指导描述',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        }
      },
      {
        $id: 'guidePath',
        $type: 'input',
        label: '指导链接地址',
        tip: {
          description: ['如果没有链接地址，只有文字描述，可把描述内容填写在“指导描述”中']
        },
        $el: {
          placeholder: '请输入指导链接地址',
          suffixIcon: 'el-icon-edit',
          type: 'textarea',
          rows: 3
        }
      },
      {
        $id: 'productSupport',
        $type: 'select',
        label: '适用产品',
        $el: {
          clearable: true,
          filterable: true,
          multiple: true
        },
        $options: 'product/findAllActive',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.id,
              label: item.productVersion
            }
          })
          if (!value) {
            return []
          }
          return Array.isArray(value) ? value : value.split(',')
        },
        rules: [
          {
            notEmpty: '适用产品'
          }
        ]
      }
    ]
  }
}
